import type { AppLocationCodec } from "@/navigation/appLocation";

export type HomeLocation = {
  review?: string;
  start?: string;
};

function fromParams(params: Record<string, string | undefined>): HomeLocation {
  const loc: HomeLocation = {};
  if (params.review === "1") {
    loc.review = "1";
  }
  const start = params.start?.trim();
  if (start) {
    loc.start = start;
  }
  return loc;
}

function fromUrl(_pathname: string, searchParams: URLSearchParams): HomeLocation {
  const loc: HomeLocation = {};
  if (searchParams.get("review") === "1") {
    loc.review = "1";
  }
  const start = searchParams.get("start")?.trim();
  if (start) {
    loc.start = start;
  }
  return loc;
}

function toParams(loc: HomeLocation): Record<string, string> {
  const out: Record<string, string> = {};
  if (loc.review === "1") {
    out.review = "1";
  }
  if (loc.start?.trim()) {
    out.start = loc.start.trim();
  }
  return out;
}

function toUrl(loc: HomeLocation): string {
  const qs = new URLSearchParams(toParams(loc)).toString();
  return qs ? `/home?${qs}` : "/home";
}

export const homeCodec: AppLocationCodec<HomeLocation> = {
  appId: "home",
  fromUrl,
  fromParams,
  toParams,
  toUrl,
};
